export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';

export const ACTIVE_PROJECT_ID = 'proj_id';
